import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-action-message-description',
  templateUrl: './action-message-description.component.html',
  standalone: true,
  styleUrls: ['./action-message-description.component.scss']
})
export class ActionMessageDescriptionComponent implements OnInit {
  @Input() primaryEntity: string;
  @Input() messageStyle = 'tip';
  @Input() messageIcon = 'error';

  actionDescription: string;

  constructor() {
  }

  ngOnInit () {
    this.actionDescription = `Deleting ${this.primaryEntity} using DataRules is irreversible. <br>Are you sure you want to proceed?`;
  }

}
